<template>
  <div class="tab-container" ref="tabContainer">
    <div class="tab-wrapper" ref="tabWrapper">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        :ref="'tabItem' + index"
        class="tab-item"
        :class="{ active: activeIndex === index }"
        @click="handleTabClick(index, item)"
      >
        <span class="tab-text">{{ item.name }}</span>
        <div class="tab-line" v-if="activeIndex === index"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTab',
  props: {
    // 选中的索引
    value: {
      type: Number,
      default: 0
    },
    // 数据列表 [{ label: '餐饮服务', name: 'cate1' }]
    tabList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: this.value
    };
  },
  watch: {
    value(val) {
      this.activeIndex = val;
      this.scrollToActive();
    }
  },
  mounted() {
    // 初始化时确保选中项居中
    this.$nextTick(() => {
      this.scrollToActive();
    });
  },
  methods: {
    handleTabClick(index, item) {
      this.activeIndex = index;
      this.$emit('input', index); // 支持 v-model
      this.$emit('change', item);
      this.scrollToActive();
    },
    // 核心逻辑：自动滚动居中
    scrollToActive() {
      const activeItem = this.$refs['tabItem' + this.activeIndex][0];
      const container = this.$refs.tabContainer;

      if (!activeItem || !container) return;

      // 计算居中偏移量
      const offsetLeft = activeItem.offsetLeft;
      const itemWidth = activeItem.clientWidth;
      const containerWidth = container.clientWidth;

      // 目标滚动距离 = 元素左偏移 - (容器宽度 / 2) + (元素宽度 / 2)
      const scrollLeft = offsetLeft - containerWidth / 2 + itemWidth / 2;

      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth' // 平滑滚动
      });
    }
  }
};
</script>

<style scoped>
/* 外层容器：负责滚动 */
.tab-container {
  width: 100%;
  overflow-x: auto; /* 开启横向滚动 */
  white-space: nowrap; /* 强制不换行 */
  background: #fff;
  /* 隐藏滚动条 (Chrome/Safari) */
  -webkit-overflow-scrolling: touch; /* 优化移动端滚动 */
}

.tab-container::-webkit-scrollbar {
  display: none; /* 全局适配通常不需要看到滚动条 */
}

/* 1. 修改 wrapper，增加居中逻辑 */
.tab-wrapper {
  display: flex;
  padding: 0 10px;
  min-width: 100%;

  /* 关键：在 PC 端，如果内容不满全屏，则居中 */
  justify-content: center;
}

.tab-item {
  position: relative;
  padding: 12px 20px;
  cursor: pointer;
  flex-shrink: 0; /* 保证不被压缩 */
  transition: all 0.3s;
  text-align: center;
}

.tab-text {
  font-size: 22px;
  color: #333;
  font-weight: 500;
}

/* 选中状态文字加粗 */
.tab-item.active .tab-text {
  color: #000;
  font-weight: bold;
}

/* 底部横条样式 */
.tab-line {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 24px; /* 横条宽度可自定 */
  height: 3px;
  background-color: #000; /* 对应图片中的黑色横条 */
  border-radius: 2px;
}

/* 手机端适配：稍微减小间距 */
@media screen and (max-width: 768px) {
  .tab-item {
    padding: 10px 15px;
  }
  .tab-text {
    font-size: 15px;
  }

  .tab-wrapper {
    /* 关键：手机端必须改回 flex-start，否则滑动会出问题 */
    justify-content: flex-start;
  }
}
</style>
